import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { CommonMessageService } from './../../../services/common-message.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-postuler',
  templateUrl: './postuler.component.html',
  styleUrls: ['./postuler.component.scss'],
})
export class PostulerComponent implements OnInit {
  @Input() cvs;
  @Input() offre;
  postForm: FormGroup;
  cvPdf: string;
  formations: any;
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private commonMessenger: CommonMessageService,
    private commonService: CommonService,
    private modalController: ModalController
  ) { }

  async ngOnInit() {
    console.log('Offre: ', this.offre);
    console.log('CVS: ', this.cvs);
    this.buildPostForm();
    await this.getFormations();
  }

  private buildPostForm() {
    this.postForm = this.fb.group({
      'motivation': ['', [Validators.required]],
      'idCv': ['', [Validators.required]],
      'idOffre': [this.offre.idOffre, [Validators.required]],
      'domaine': ['']
    });
  }

  async getFormations() {
    this.formations = (await this.commonService.formations().toPromise()) as any;
  }

  async post() {
    if (this.cvPdf === null || this.cvPdf === undefined || this.cvPdf === '') {
      this.commonMessenger.errorToast('Merci d\'ajouter votre cv en pdf');
      return;
    }

    console.log('CV: ', this.postForm.value);
    const data = {
      idCv: Number(this.postForm.value.idCv),
      idOffre: Number(this.postForm.value.idOffre),
      motivation: this.postForm.value.motivation,
      login: this.userService.currentUser.loginEmail,
      cvPdf: this.cvPdf,
      domaine: this.postForm.value.domaine
    };
    const loading = await this.commonMessenger.loading('Patientez un instant...');
    try {
      const res = await this.commonService.post(data).toPromise();
      console.log('Res; ', res);
      this.commonMessenger.successToast('Votre demande a été prise en compte, vous recevrez un email dans un instant');
      this.close(res);
    } catch (error) {
      this.commonMessenger.errorToast('Erreur: ' + error);
    } finally {
      loading.dismiss();
    }
  }
  close(data?) {
    this.modalController.dismiss(data);
  }

  async detectFiles0(event) {
    console.log('files: ', event.target.files);
    const files = [];
    for (let i = 0; i < event.target.files.length; i++) {
      files.push(event.target.files[i]);
    }
    await Promise.all(files.map(async file => {
      try {
        if (file.size > 5000000 || !(file.type === 'application/pdf')) {
          if (file.size > 5000000) {
            this.commonMessenger.errorToast('Merci de choisir une taille plus petite !!!');
            return;
          } else {
            this.commonMessenger.errorToast('Merci de choisir un fichier au format pdf');
            return;
          }
        }
        this.commonMessenger.successToast('Chargement effectué avec succès, merci d\'envoyer maintenant');
        this.cvPdf = (await this.commonService.sendToOpenStack(file, files.indexOf(file)).toPromise() as any).message;
      } catch (error) {
      }
    }));
    console.log('cvPdf: ', this.cvPdf);
  }
}
